// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2Nigk","itemTitle":"ClientEmergencyInfo_itemTitle__uFOFD","itemText":"ClientEmergencyInfo_itemText__1iQvc"};